import { requisitarJson } from '../../../shared/api/http';

export type SituacaoDaTurmaId = 'nao_iniciada' | 'em_andamento' | 'encerrada';

export interface SituacaoDaTurma {
    turma_id: string;
    situacao: SituacaoDaTurmaId;
    iniciada_em: string | null;
    encerrada_em: string | null;
    reaberta_em: string | null;
}

export interface TurmaFinalizada extends SituacaoDaTurma {
    estacoes_finalizadas: number;
    fases_encerradas: number;
    sessoes_encerradas: number;
}

export type ComandoDaTurma = 'iniciar' | 'finalizar' | 'reabrir';

const caminho = (turmaId: string) => `/api/v1/turmas/${encodeURIComponent(turmaId)}`;

export function obterSituacaoDaTurma(turmaId: string): Promise<SituacaoDaTurma> {
    return requisitarJson(caminho(turmaId));
}

export function comandarTurma(
    turmaId: string,
    comando: ComandoDaTurma,
    csrfToken: string,
): Promise<SituacaoDaTurma | TurmaFinalizada> {
    return requisitarJson(`${caminho(turmaId)}/${comando}`, { method: 'POST', csrfToken });
}
